<template>
  <div>
    <Dashboard />
  </div>
</template>

<script>
import Dashboard from '@/pages/dashboard/Index'

export default {
  components: {
    Dashboard
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_dashboard')) {
        if (vm.$store.state.auth.permissions.includes('manage_news')) {
          vm.$router.push('/news')
        } else if (vm.$store.state.auth.permissions.includes('manage_work_with_us')) {
          vm.$router.push('/work-with-us')
        } else {
          vm.$router.push('/404')
        }
      }
    })
  },

  data() {
    return {
      userType: null
    }
  },

  metaInfo: {
    title: 'Dashboard',
    titleTemplate: ' %s - Manager -- Intelli'
  }

}
</script>
